<template>
    <div class="header">
        <div class="header-within">
            <div class="header-top">
                <div style="width: 1300px; margin: 0 auto;display: flex;justify-content: space-between;align-items: center;">
                    <div class="header-top-left">
                        <img src="../../assets/img/logo.png" alt="" class="logo" />
                        <div class="logo-right-text" >教学成果奖申报展示网</div>
                    </div>

                    <div class="right">
                        <div class="right-left">
                            <el-input
                                suffix-icon="el-icon-search"
                                v-model="input2">
                            </el-input>
                            <!-- <input type="text" class="inp" suffix-icon="el-icon-search">
                            <img src="" alt="" class="search-logo"> -->
                        </div>
                        <div class="header-top-right">
                            <a href="http://27.195.3.174:8086/" target="_blank">
                                <div class="left">登录 <span style="margin: 0 10px;opacity: .7;">|</span> 注册</div>
                            </a>
                        </div>
                        <!-- <div style="display: flex;">
                            <el-input class="inp" type="text" placeholder="请输入搜索类名" @keyup.enter.native="toSearch($event)" v-model="searchName" v-if="RouteState">
                                <i slot="prefix" class="el-input__icon el-icon-search"></i>
                            </el-input>
                                                
                        </div> -->
                    </div>
                </div>
            </div>
            <div class="top-bottom">
                <img src="../../assets/img/home-top-img.png" alt="">
            </div>
            <!-- <img src="../../public/banner/shouyebanner.png" alt="" class="header-banner" v-show="tab==0">
      <img src="../../public/banner/rencaizhengce.png" alt="" class="header-banner" v-show="tab==1">
      <img src="../../public/banner/rencaimabanner.png" alt="" class="header-banner" v-show="tab==3">
      <img src="../../public/banner/rencaigongchengbanner.png" alt="" class="header-banner" v-show="tab==4">
      <img src="../../public/banner/guaishuai.png" alt="" class="header-banner" v-show="tab==10">
      <img src="../../public/banner/rencaichaoshi.png" alt="" class="header-banner" v-show="tab==11">
      <img src="../../public/banner/rencaifuwu.png" alt="" class="header-banner" v-show="tab==12"> -->
        </div>
    </div>
</template>

<script>
import { color } from "echarts";
import { mapMutations, mapState } from "vuex";
export default {
    name: "Header",
    data() {
        return {
            tab: this.$store.state.CommonHeader.tab ? this.$store.state.CommonHeader.tab : 0, //0：首页   1：信息公开    2：国际经贸促进   3：国际联络    4：会展服务    5：投资促进    6：商事法律    7：国际商会    8：关于我们

            select: '/',

            RouteState:true,

            searchName: "", // 搜索框输入的文字
        };
    },
    computed: {
        ...mapState("CommonHeader", ["nav", "Games", "isShowli"]),
        counts() {
            return this.$store.state.CommonHeader.tab;
        },
    },
    mounted() {
        this.tab = this.counts;
        console.log(this.$downloadUrl)
    },
    methods: {
        ...mapMutations("CommonHeader", ["Flagt", "Flagf"]),
        // 输入框的方法
        toSearch(event) {
            if(event) {
                event.target.blur()
            }
            this.tabClick(10);
            console.log(this.searchName);
            console.log(this.$route.path);
            if(this.$route.path == '/searchResult') {
                this.RouteState = false;
                this.$nextTick(()=>{
                    this.RouteState = true;
                });
            }

            // this.RouteState = false;
            // this.$nextTick(()=>{
            //     this.RouteState = true;
            // });
            
            this.$router.push({
                path: '/searchResult',
                query: {
                    tab: '10',
                    value: this.searchName
                }
            })
            // this.$router.options.routes.forEach(item => {
            //     if(item.path == '/searchResult') {
            //         this.$router.options.routes.slice(item, 1)
            //         console.log(this.$router.options.routes);
            //     }
            //     this.$router.push({
            //         path: '/searchResult',
            //         query: {
            //             tab: '10',
            //             value: this.searchName
            //         }
            //     })
            // })
            
            console.log(this.$router);
        },

        tabClick(tab) {
            console.log(this.tab);
            this.$store.state.CommonHeader.tab = tab;
            this.tab = tab ?tab : 0
            console.log(tab == 0);
            if (tab == 0) {
                // this.$router.push("/home");

                this.select = '/home'
                sessionStorage.setItem('tab', this.select)
                this.$router.push({
                    path: this.select,
                    query: {
                        tab: this.tab
                    },
                })
            } else if (tab == 1) {
                this.$router.push({
                    path: "/zhuanyequn",
                    query: {
                        tab: this.tab,
                        type: 9,
                    },
                });
            } else if (tab == 2) {
                this.$router.push({
                    path: "/lianheti",
                    query: {
                        tab: this.tab,
                        type: 7,
                    },
                });
            } else if (tab == 3) {
                this.$router.push({
                    path: "/gongtongti",
                    query: {
                        tab: this.tab,
                        type: 5,
                    },
                });
            } else if (tab == 4) {
                this.$router.push({
                    path: "/chengguozhanshi",
                    query: {
                        tab: this.tab,
                        type: 19,
                    },
                });
            }
        }
    },
    created() {
        // 在页面加载时读取sessionStorage
        if (sessionStorage.getItem("select")) {
            this.$store.replaceState(
                Object.assign(
                    {},
                    this.$store.state,
                    JSON.parse(sessionStorage.getItem("select"))
                )
            );
        }
        // 在页面刷新时将store保存到sessionStorage里
        window.addEventListener("beforeunload", () => {
            sessionStorage.setItem("select", JSON.stringify(this.$store.state));
        });
    },
    
    watch: {
        counts(newVal, oldVal) {
            this.tab = newVal;
        },
        // tab() {
        //     this.$store.state.CommonHeader.tab = this.tab;
        //     console.log(this.tab);
        //     if (this.tab == 0) {
        //         this.$router.push("/home");
        //     } else if (this.tab == 1) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: 9,
        //             },
        //         });
        //     } else if (this.tab == 2) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: 7,
        //             },
        //         });
        //     } else if (this.tab == 3) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: 5,
        //             },
        //         });
        //     } else if (this.tab == 4) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: 19,
        //             },
        //         });
        //     } else if (this.tab == 5) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: 6,
        //             },
        //         });
        //     } else if (this.tab == 6) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: 12,
        //             },
        //         });
        //     } else if (this.tab == 7) {
        //         this.$router.push({
        //             path: "/hometwo",
        //             query: {
        //                 tab: this.tab,
        //                 type: this.type,
        //             },
        //         });
        //     }
        // },
    },
};
</script>

<style lang="less" scoped>
.header {
    width: 100%;
    //   width: 100%;
    overflow: hidden;
    // margin-left: 100px;
    margin: 0 auto;
    background-color: #fff;
    

    .header-within {
        width: 100%;
        position: relative;
        z-index: 10;

        .header-top {
            width: 100%;
            
            padding: 25px;
            // width: calc(100% - 40px);
            background-color: #0527AF;
            
            // background-image: url('@/assets/img/top-banner-bg.png');
            // background-size: 100% 100%;
            .header-top-left {
                display: flex;
                align-items: center;
                .logo {
                    // width: 62px;
                    height: 50px;
                }
                .logo-right-text {
                    color: #fff;
                    font-size: 18px;
                    margin-left: 60px;
                }
                
            }
            .right {
                
                text-align: center;
                display: flex;
                align-items: center;
                .right-left {
                    :deep(.el-input--suffix .el-input__inner) {
                        height: 30px;
                        line-height: 30px;
                        border-radius: 20px;
                        width: 300px;
                    }
                    :deep(.el-input__icon) {
                        line-height: 30px;
                        font-size: 19px;
                        color: #333;
                    }
                }
            }
            .header-top-right {
                text-align: center;
                // border: 1px solid #b5b5b5;
                // border-radius: 30px;
                // display: flex;
                // justify-content: space-between;
                height: 40px;
                line-height: 38px;
                // align-items: center;
                font-size: 14px;

                margin-left: 30px;
                .left {
                    width: 100%;
                    text-align: center;
                    text-align: center;
                    color: #fff;
                }
                .right {
                    width: 120px;
                    text-align: center;
                    color: #fff;
                }
                .center {
                    width: 1px;
                    height: 100%;
                    background-color: #fff;
                }
            }
            // .search {
            //     width: 40px;
            //     height: 42px;
            //     color: "#999";
            //     background-color: #174199;
            //     display: flex;
            //     justify-content: center;
            //     align-items: center;
            // }
            // .center {
            //     width: 1px;
            //     height: 100%;
            //     background-color: #b5b5b5;
            // }

            
        }
        .top-bottom {
            width: 100%;
            height: 350px;
            img {
                width: 100%;
                height: 100%;
            }
        }
    }
}

/* pad */
@media screen and (max-width: 1199px) and (min-width: 600px) {
    .header {
        width: 1000px;
        overflow: hidden;
        // height: 520px;
        margin-left: 100px;
        margin: 0 auto;
        .header-within {
            width: 100%;
            position: relative;

            .navigation {
                display: flex;
                justify-content: space-between;
                background: #005190;
                margin-top: 20px;
                padding: 0 20px;
                height: 40px;
                .view {
                    border-radius: 10px;
                    margin-top: 3px;
                    height: 90%;
                    width: 13%;
                    cursor: pointer;
                    .top {
                        text-align: center;
                        margin-top: 13px;
                        font-size: 18px;
                        color: #ffffff;
                    }
                    .bottom {
                        text-align: center;
                        margin-top: 13px;
                        font-size: 10px;
                        color: #ffffff;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                    }
                }
            }
            .header-banner {
                width: 100%;
                height: 336px;
            }

            .header-top {
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-top: 20px;
                width: calc(100% - 40px);
                // .header-top-left {
                //     margin-left: 24px;
                //     .top {
                //         color: #174199;
                //         font-size: 31px;
                //     }
                //     .bottom {
                //         color: #272727;
                //         font-size: 20px;
                //         margin-top: 10px;
                //     }
                // }

                .header-top-logo {
                    padding-left: 40px;
                    /*background-color: #e9852d;*/
                    /*  margin-top: 0px;*/
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                .header-top-right {
                    border: 1px solid #b5b5b5;
                    border-radius: 30px;
                    padding: 10px 0;
                    display: flex;
                    justify-content: space-between;
                    height: 40px;
                    align-items: center;
                    .left {
                        width: 120px;
                        text-align: center;
                        color: #555;
                    }
                    .right {
                        width: 120px;
                        text-align: center;
                        color: #555555;
                    }
                    .center {
                        width: 1px;
                        height: 100%;
                        background-color: #b5b5b5;
                    }
                }
            }
        }
    }
}
/* 移动端 */
</style>
